// 📁 src/components/CustomZoomControl.jsx
import { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { FaPlus, FaMinus } from "react-icons/fa";
import { createRoot } from "react-dom/client";

export default function CustomZoomControl() {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    

    const control = L.control({ position: "bottomright" });

    control.onAdd = function () {
      const container = L.DomUtil.create("div", "leaflet-control leaflet-bar");
      container.style.cssText = `
        background: rgba(255, 255, 255, 0.9);
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5px;
      `;

      const btnStyle = `
        cursor: pointer;
        background: white;
        border-radius: 8px;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 6px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        transition: 0.2s;
      `;

      // 🔹 Bouton Zoom In
      const zoomInBtn = L.DomUtil.create("div", "", container);
      zoomInBtn.style.cssText = btnStyle;
      zoomInBtn.title = "Zoom in";
      createRoot(zoomInBtn).render(<FaPlus size={18} color="#2980b9" />);

      // 🔹 Bouton Zoom Out
      const zoomOutBtn = L.DomUtil.create("div", "", container);
      zoomOutBtn.style.cssText = btnStyle;
      zoomOutBtn.title = "Zoom out";
      createRoot(zoomOutBtn).render(<FaMinus size={18} color="#2980b9" />);

      // 🔹 Hover effect
      [zoomInBtn, zoomOutBtn].forEach((btn) => {
        btn.onmouseenter = () => {
          btn.style.transform = "scale(1.1)";
          btn.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
        };
        btn.onmouseleave = () => {
          btn.style.transform = "scale(1)";
          btn.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
        };
      });

      // 🔹 Actions
      L.DomEvent.on(zoomInBtn, "click", (e) => {
        L.DomEvent.stopPropagation(e);
        map.zoomIn();
      });

      L.DomEvent.on(zoomOutBtn, "click", (e) => {
        L.DomEvent.stopPropagation(e);
        map.zoomOut();
      });

      return container;
    };

    control.addTo(map);
    return () => control.remove();
  }, [map]);

  return null;
}
